let locales = [
    {
        name: 'en',
        title: 'English',
        language: 'en',
        isRtl: false,
        icon: 'en.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: [],
        loadFallbackLocales: false,
        hreflang: 'en',
        languageCode: 'en',
        languageCountryCode: 'en-GB',
    },
    {
        name: 'en-US',
        title: 'English',
        language: 'en',
        isRtl: false,
        icon: 'map.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: true,
        hreflang: 'en-US',
        languageCode: 'en',
        languageCountryCode: 'en-US',
    },
    {
        name: 'ar',
        title: 'اللغة العربية',
        language: 'ar',
        isRtl: true,
        icon: 'ar.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'ar',
        languageCode: 'ar',
        languageCountryCode: 'ar-AR',
    },
    {
        name: 'de',
        title: 'Deutsch',
        language: 'de',
        isRtl: false,
        icon: 'de.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'de',
        languageCode: 'de',
        languageCountryCode: 'de-DE',
    },
    {
        name: 'ru',
        title: 'Русский',
        language: 'ru',
        isRtl: false,
        icon: 'ru.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'ru',
        languageCode: 'ru',
        languageCountryCode: 'ru-RU',
    },
    {
        name: 'es',
        title: 'Español',
        language: 'es',
        isRtl: false,
        icon: 'map.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'es',
        languageCode: 'es',
        languageCountryCode: 'es-ES',
    },
    {
        name: 'es-ar',
        title: 'Español',
        language: 'es-ar',
        isRtl: false,
        icon: 'map.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['es'],
        loadFallbackLocales: true,
        hreflang: 'es-ar',
        languageCode: 'es',
        languageCountryCode: 'es-AR',
    },
    {
        name: 'pt',
        title: 'Português (Brasil)',
        language: 'pt',
        isRtl: false,
        icon: 'pt-br.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'pt',
        languageCode: 'pt',
        languageCountryCode: 'pt-PT',
    },
    {
        name: 'pt-br',
        title: 'Português (Brasil)',
        language: 'pt-br',
        isRtl: false,
        icon: 'pt-br.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['pt'],
        loadFallbackLocales: true,
        hreflang: 'pt-br',
        languageCode: 'pt',
        languageCountryCode: 'pt-BR',
    },
    {
        name: 'fr',
        title: 'Français',
        language: 'fr',
        isRtl: false,
        icon: 'fr.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'fr',
        languageCode: 'fr',
        languageCountryCode: 'fr-FR',
    },
    {
        name: 'pl',
        title: 'Polskie',
        language: 'pl',
        isRtl: false,
        icon: 'pl.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'pl',
        languageCode: 'pl',
        languageCountryCode: 'pl-PL',
    },
    {
        name: 'ja',
        title: '日本語',
        language: 'ja',
        isRtl: false,
        icon: 'ja.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'ja',
        languageCode: 'ja',
        languageCountryCode: 'ja-JP',
    },
    {
        name: 'ms',
        title: 'Bahasa Melayu',
        language: 'ms',
        isRtl: false,
        icon: 'ms.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'ms',
        languageCode: 'ms',
        languageCountryCode: 'ms-MY',
    },
    {
        name: 'fi',
        title: 'Suomi',
        language: 'fi',
        isRtl: false,
        icon: 'fi.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'fi',
        languageCode: 'fi',
        languageCountryCode: 'fi-FI',
    },
    {
        name: 'tr',
        title: 'Türkçe',
        language: 'tr',
        isRtl: false,
        icon: 'tr.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'tr',
        languageCode: 'tr',
        languageCountryCode: 'tr-TR',
    },
    {
        name: 'zh',
        title: '汉语',
        language: 'zh',
        isRtl: false,
        icon: 'zh.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'zh-sg',
        languageCode: 'zh',
        languageCountryCode: 'en-GB',
    },
    {
        name: 'no',
        title: 'Norsk',
        language: 'no',
        isRtl: false,
        icon: 'no.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'nn-no',
        languageCode: 'no',
        languageCountryCode: 'nn-no',
    },
    {
        name: 'he',
        title: 'עברית',
        language: 'he',
        isRtl: true,
        icon: 'he.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'he',
        languageCode: 'he',
        languageCountryCode: 'he-IL'
    },
    {
        name: 'it',
        title: 'Italiano',
        language: 'it',
        isRtl: false,
        icon: 'it.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'it',
        languageCode: 'it',
        languageCountryCode: 'it-IT'
    },
    {
        name: 'ro',
        title: 'Română',
        language: 'ro',
        isRtl: false,
        icon: 'ro.png',
        dateFormat: 'DD/MM/YYYY',
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
        timeFormat: 'HH:mm',
        phpDateFormat: 'd/m/Y',
        phpDateTimeFormat: 'd/m/Y H:i',
        phpTimeFormat: 'H:i',
        fallbackLocales: ['en'],
        loadFallbackLocales: false,
        hreflang: 'ro',
        languageCode: 'ro',
        languageCountryCode: 'ro-RO'
    }
];

let defaultLanguage = process.env.DEFAULT_LOCALE || 'en';

let availableLocalesNames = process.env.AVAILABLE_LOCALES ? process.env.AVAILABLE_LOCALES.split(',') : [defaultLanguage];
let publicLocalesNames = process.env.PUBLIC_LOCALES ? process.env.PUBLIC_LOCALES.split(',') : [defaultLanguage];

let appLocales = locales.filter(locale => availableLocalesNames.includes(locale.name));

let publicAppLocales = publicLocalesNames.map(localeName => locales.find(locale => locale.name === localeName)).filter(locale => locale);

let autoDetectUserLanguage = process.env.AUTO_DETECT_USER_LANGUAGE  === 'true';

//todo make dynamic, support multiple groups and translate titles
let appCountries = {
    defaultCountry: process.env.DEFAULT_COUNTRY,
    countriesGroups: [
        {
            countries: process.env.COUNTRIES_GROUP ? process.env.COUNTRIES_GROUP.split(',') : [],
        }
    ],
};

module.exports = {
    appLocales: appLocales,
    publicAppLocales: publicAppLocales,
    availableLocalesNames: availableLocalesNames,
    publicLocalesNames: publicLocalesNames,
    defaultLanguage: defaultLanguage,
    autoDetectUserLanguage: autoDetectUserLanguage,
    appCountries: appCountries,
};
